import { debug } from "../utils";

const sessionStorageKeyPrefix = "dx-sgconnect-login";

export const storeLastLoginAttempt = () => {
  const timestamp = new Date().valueOf();
  sessionStorage.setItem(
    `${sessionStorageKeyPrefix}${timestamp}`,
    timestamp.toString()
  );
};

const getSessionStorageLoginAttemptKeys = () =>
  Object.keys(sessionStorage).filter((x) =>
    x.startsWith(sessionStorageKeyPrefix)
  );

export const hasTooManyAttemptedLogins = () => {
  const hasTooMany = getSessionStorageLoginAttemptKeys().length >= 5;
  if (hasTooMany) {
    debug("User has been redirected without success 5 times or more");
  }
  return hasTooMany;
};

export const clearLoginAttempts = () => {
  getSessionStorageLoginAttemptKeys().forEach((key) =>
    sessionStorage.removeItem(key)
  );
};
